<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :right="($vuetify.rtl == true || $vuetify.rtl == 1 ? true : false)"
    :mini-variant.sync="mini"
    :permanent="(!isMobile ? true : false)"
    mobile-breakpoint="960"
    app
    width="230"
    v-bind="$attrs"
    :class="{'appBarsOpacity': $store.state.appBarsOpacity, 'white': !$store.state.appBarsOpacity}"
    style="z-index: 8 !important;"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="($vuetify.theme.dark ? `to bottom, ${barColor}` : '' )"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1" />
    <v-list
      dense
      nav
      height="45"
      class="pa-0 px-1"
    >
      <v-list-item>
        <v-list-item-avatar class="my-1">
          <v-img
            v-if="!$store.state.logo"
            class="mb-3"
            src="https://abriransystem.ir/wp-content/uploads/2018/07/logo-png.png"
          />
          <v-img
            v-if="$store.state.logo"
            class="mb-3"
            :src="$store.state.logo"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            style="white-space: nowrap !important;"
            v-text="$store.state.abrName"
          />
          <v-list-item-subtitle style="font-size: x-small">
            {{ $t('currency') }} : {{ $store.state.currency.name }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="my-0 mx-0">
          <v-btn
            icon
            x-small
            @click.stop="mini = !mini"
          >
            <v-icon
              small
              color="primary"
            >
              {{ ($vuetify.rtl ? 'mdi-chevron-right' : 'mdi-chevron-left') }}
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider class="mb-2" />
    <!--    <v-col-->
    <!--      v-show="!mini"-->
    <!--      class="px-2 pt-0 pb-4"-->
    <!--      cols="12"-->
    <!--    >-->
    <!--      <v-text-field-->
    <!--        v-model="search"-->
    <!--        solo-->
    <!--        flat-->
    <!--        hide-details-->
    <!--        :placeholder="$t('doSearch')"-->
    <!--        clearable-->
    <!--        height="30"-->
    <!--        :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"-->
    <!--        dense-->
    <!--      />-->
    <!--    </v-col>-->
    <!--    <v-list-item-->
    <!--      v-for="(child, index) in searchItems"-->
    <!--      v-show="searchItems && searchItems.length > 0"-->
    <!--      :key="index"-->
    <!--      style="min-height: 20px"-->
    <!--      @click="open(child)"-->
    <!--    >-->
    <!--      <v-list-item-content class="py-0 px-3">-->
    <!--        <v-list-item-title-->
    <!--          style="font-size: 11px"-->
    <!--          v-text="$t(child.title)"-->
    <!--        />-->
    <!--      </v-list-item-content>-->
    <!--      <v-list-item-icon class="my-0 ">-->
    <!--        <v-tooltip bottom>-->
    <!--          <template v-slot:activator="{ on, attrs }">-->
    <!--            <v-btn-->
    <!--              v-bind="attrs"-->
    <!--              icon-->
    <!--              x-small-->
    <!--              v-on="on"-->
    <!--              @click.stop.prevent="createShortcut(child)"-->
    <!--            >-->
    <!--              <v-icon-->
    <!--                style="font-size: 16px !important;"-->
    <!--                color="blue-grey"-->
    <!--              >-->
    <!--                mdi-pin-outline-->
    <!--              </v-icon>-->
    <!--            </v-btn>-->
    <!--          </template>-->
    <!--          <span>{{ $t('addToDesk') }}</span>-->
    <!--        </v-tooltip>-->
    <!--        <v-tooltip bottom>-->
    <!--          <template v-slot:activator="{ on, attrs }">-->
    <!--            <v-btn-->
    <!--              v-bind="attrs"-->
    <!--              icon-->
    <!--              x-small-->
    <!--              v-on="on"-->
    <!--              @click.stop.prevent="openNewTab(child)"-->
    <!--            >-->
    <!--              <v-icon-->
    <!--                style="font-size: 16px !important;"-->
    <!--                color="primary"-->
    <!--              >-->
    <!--                mdi-content-duplicate-->
    <!--              </v-icon>-->
    <!--            </v-btn>-->
    <!--          </template>-->
    <!--          <span>{{ $t('newTab') }}</span>-->
    <!--        </v-tooltip>-->
    <!--      </v-list-item-icon>-->
    <!--    </v-list-item>-->
    <div v-show="!searchItems || searchItems && searchItems.length == 0">
      <v-list flat>
        <v-list-item
          v-for="(item, j) in $store.state.topMenu"
          v-show="!item.hide"
          :key="j + 'key'"
          class="px-0 pt-0"
          @click="open({to : item.to})"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon" />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="$t(item.title)" />
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-for="(item, i) in computedItems"
          v-show="!item.hide && item.to != 'other'"
          :key="i"
          v-model="item.active"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title" />
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, index) in item.children"
            v-show="!child.hide && child.show"
            :key="index"
            :style="{'min-height' : (child.to === 'divider' ? '6px' : '20px')}"
            @click="open(child)"
          >
            <v-divider v-if="child.to === 'divider'" />
            <v-list-item-content
              v-if="child.to !== 'divider'"
              class="py-0 px-3"
            >
              <v-list-item-title
                style="font-size: 11px"
                :style="{'color': (child.color ? ($vuetify.theme.isDark ? 'white' : child.color) : null)}"
                v-text="child.title"
              />
            </v-list-item-content>
            <v-list-item-icon
              v-if="child.to !== 'divider'"
              class="my-0 "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="child.add"
                    v-bind="attrs"
                    icon
                    x-small
                    v-on="on"
                    @click.stop.prevent="open(child.add)"
                  >
                    <v-icon
                      style="font-size: 16px !important;"
                      color="primary"
                    >
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span v-if="child.add">{{ $t(child.add.title) }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    icon
                    x-small
                    v-on="on"
                    @click.stop.prevent="createShortcut(child)"
                  >
                    <v-icon
                      style="font-size: 16px !important;"
                      color="blue-grey"
                    >
                      mdi-pin-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('addToDesk') }}</span>
              </v-tooltip>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <!--      <v-list-item-group-->
        <!--        color="indigo"-->
        <!--      >-->
        <!--      </v-list-item-group>-->
      </v-list>
      <v-list flat>
        <v-list-item-group
          color="indigo"
        >
          <v-list-item
            @click="openiframe()"
          >
            <!--          <v-list-item-icon>-->
            <!--            <v-icon v-text="item.icon" />-->
            <!--          </v-list-item-icon>-->
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <!--    <template v-slot:append>-->
    <!--      <base-item-->
    <!--        :item="{-->
    <!--          title: $t('upgrade'),-->
    <!--          icon: 'mdi-package-up',-->
    <!--          to: '/upgrade',-->
    <!--        }"-->
    <!--      />-->
    <!--    </template>-->
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapState,
  mapActions
} from 'vuex'
import General from '../../../../Mixins/general'
export default {
  name: 'DashboardCoreDrawer',
  mixins: [General],
  props: {
    expandOnHover: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    items: [],
    search: null,
    searchItems: [],
    mini: false
  }),
  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get () {
        return this.$store.state.drawer
      },
      set (val) {
        this.$store.commit('SET_DRAWER', val)
      }
    },
    permissions: {
      get () {
        return this.$store.state.permissions
      },
      set (val) {
        this.$store.commit('SET_PERMISSIONS', val)
      }
    },
    hoverMenu: {
      get () {
        return this.$store.state.hoverMenu
      },
      set (val) {
        this.$store.commit('SET_HOVERMENU', val)
      }
    },
    computedItems () {
      return this.items.map(this.mapItem)
    },
    profile () {
      return {
        avatar: true,
        // title: this.$t('avatar'),
        title: this.$t('abriron')
      }
    },
    isMobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    }
  },
  watch: {
    permissions () {
      this.checkBookmark()
    },
    search (val) {
      this.searchItems = []
      if (val && val.length > 1) {
        var app = this
        this.computedItems.map(function (items, index) {
          if (items.children) {
            items.children.map(function (item) {
              if (app.$t(item.title).toLowerCase().includes(app.search.toLowerCase()) && item.show) {
                app.searchItems.push(item)
              }
            })
          }
        })
      }
    },
    hoverMenu () {
      if (this.hoverMenu) {
        this.mini = false
      } else {
        this.mini = true
      }
    }
  },
  beforeMount () {
    if (!this.isMobile) {
      this.drawer = true
    }
    if (this.hoverMenu) {
      this.mini = false
    } else {
      this.mini = true
    }
    this.getPermissions()
  },
  methods: {
    ...mapActions([
      'SET_MENU_BOOKMARK'
    ]),
    addBookmark (item) {
      var app = this
      item.bookmark = true
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          key: 'menuBookmark',
          value: item.to,
          select: 'addBookmark'
        }
      })
        .then(res => {
          res = res.data
          var menu = app.$store.state.menuBookmark
          if (menu) {
            menu[menu.length] = { key: 'menuBookmark', value: item.to }
          } else {
            menu = [{ key: 'menuBookmark', value: item.to }]
          }
          // app.SET_MENU_BOOKMARK(menu)
          app.$store.commit('SET_MENU_BOOKMARK', menu)
          var storage = JSON.parse(localStorage.getItem('token'))
          storage.init.menuBookmark = menu
          localStorage.setItem('token', JSON.stringify(storage))
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.isLoading = false))
    },
    removeBookmark (item) {
      var app = this
      item.bookmark = false
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          key: 'menuBookmark',
          value: item.to,
          select: 'removeBookmark'
        }
      })
        .then(res => {
          res = res.data
          var menu = app.$store.state.menuBookmark
          var index = app.$store.state.menuBookmark.findIndex(x => x.value === item.to)
          menu.splice(index, 1)
          app.$store.commit('SET_MENU_BOOKMARK', menu)
          item.bookmark = false
          var storage = JSON.parse(localStorage.getItem('token'))
          storage.init.menuBookmark = menu
          localStorage.setItem('token', JSON.stringify(storage))
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.isLoading = false))
    },
    openiframe () {
      this.$router.push({ name: 'iframe' })
    },
    mapItem (item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title, { name: this.$store.state.studentLabel })
      }
    },
    open (item) {
      if (!this.hoverMenu && this.mini) {
        return false
      }
      this.$router.push({ name: item.to, params: item.params })
      if (this.isMobile) {
        this.drawer = false
      } else {
        this.mini = false
      }
    },
    openNewTab (item) {
      var routeData = this.$router.resolve({ name: item.to, query: { data: item.params } })
      window.open(routeData.href, '_blank')
    },
    addHoverState (child, state) {
      setTimeout(function () {
        child.isHovered = !child.isHovered
        console.log(child.isHovered)
      }, 1000)
      // this.$set(child, 'isHovered', state)
    }
  }

}
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list
    padding-top: 0px
  .v-list-item__content
    padding: 0px 0px
  ::-webkit-scrollbar
    width: 15px
  ::-webkit-scrollbar-track
    background: #f5f5f5
    border-left: 1px solid #dadada
    width: 15px
  ::-webkit-scrollbar-thumb
    background: #dadada
    border: solid 3px #f5f5f5
    border-radius: 1px
    width: 15px
  ::-webkit-scrollbar-thumb:hover
    background: #9b9b9b
  .v-list-group
    .v-list-item
      .v-list-item__icon
        .v-icon
          font-size: 20px !important
  .v-list-group__header.v-list-item--active:before
    opacity: .24
  .v-list-item__icon
    margin: 4px 0px
  .v-list-item__action, .v-list-item__avatar, .v-list-item__icon
    min-width: 20px
  .v-list-item__title
      font-size: 12px
      white-space: normal
  .v-list-item
    padding: 0px 4px !important
    min-height: 24px
  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
